import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["profilesSelect"]

  connect() {
    const checkbox = this.element.querySelector("input[type='checkbox']")
    if (checkbox && checkbox.checked) {
      this.toggle({ currentTarget: checkbox })
    }
  }

  toggle(event) {
    const checkbox = event.currentTarget
    const select = this.profilesSelectTarget
    const dropdownElement = select.closest(".ui.dropdown")

    if (!dropdownElement) return

    if (checkbox.checked) {
      if (!select.dataset.originalOptions) {
        select.dataset.originalOptions = select.innerHTML
      }

      while (select.firstChild) {
        select.removeChild(select.firstChild)
      }

      const option = document.createElement("option")
      option.value = ""
      option.textContent = select.dataset.adminLabel
      option.selected = true
      select.appendChild(option)

      select.setAttribute("disabled", "disabled")

      if (typeof $(dropdownElement).dropdown === "function") {
        $(dropdownElement).dropdown("clear")
        $(dropdownElement).addClass("disabled")
        $(dropdownElement).find(".text").text(select.dataset.adminLabel)
        $(dropdownElement).dropdown("refresh")
      }
    } else {
      select.removeAttribute("disabled")

      if (select.dataset.originalOptions) {
        select.innerHTML = select.dataset.originalOptions
      }

      if (typeof $(dropdownElement).dropdown === "function") {
        $(dropdownElement).removeClass("disabled")
        $(dropdownElement).dropdown("clear")
        $(dropdownElement).find(".text").text("")
        $(dropdownElement).dropdown("refresh")
      }
    }
  }
}
